import { render, staticRenderFns } from "./HotSchemeTextList.vue?vue&type=template&id=648e997f&scoped=true&"
import script from "./HotSchemeTextList.vue?vue&type=script&lang=js&"
export * from "./HotSchemeTextList.vue?vue&type=script&lang=js&"
import style0 from "./HotSchemeTextList.vue?vue&type=style&index=0&id=648e997f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e997f",
  null
  
)

export default component.exports